import {IJackpotsService} from "../../services/jackpots/jackpots.service.interface";
import {makeObservable, observable, runInAction} from "mobx";
import {NullableJackpotViewModel} from "../../services/jackpots/models/jackpot.view-model.interface";

export class TitanJackpotWidgetController {
    constructor(private readonly jackpotService: IJackpotsService) {
        makeObservable(this)
    }

    @observable.ref
    private _jackpot: NullableJackpotViewModel;
    get jackpot(): NullableJackpotViewModel {
        return this._jackpot;
    }


    public async updateJackpotHandler(jackpotId: string): Promise<void> {

        runInAction(() => {
            this._jackpot = this.jackpotService.getJackpot(jackpotId);
        });

        await this.jackpot?.startWidgetAmountAnimation();


    }

}